interface AppInsights {
    addTelemetryInitializer: (callback: (item: any) => boolean) => void;
}

jQuery(() => {
    const appInsights: AppInsights | undefined = (window as any).appInsights;

    if (appInsights && appInsights.addTelemetryInitializer) {
        appInsights.addTelemetryInitializer((item) => {
            if (item.baseType !== 'ExceptionData') {
              return true
            }
            // This is a workaround to avoid the same-origin policy error spam
            // Same code snippet is also injected in the Store AppInsightsService
            if (item.baseData && typeof (item.baseData.exceptions) === 'undefined'
              && item.baseData.message
              && item.baseData.message.includes('same-origin policy prevents us from getting the details of this exception')) {
              return false
            }

            return true
          })
    }
})